import { render, staticRenderFns } from "./DashFornecedor.vue?vue&type=template&id=911e8c40"
import script from "./DashFornecedor.vue?vue&type=script&lang=js"
export * from "./DashFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports